export enum FormPostSubmitAction {
  REDIRECT = 'redirect',
}
